var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/Link/Link.jinja"] = require( "front/components/Link/Link.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Responsible/Responsible.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Responsible/Responsible.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Responsible/Responsible.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "svgSprite")) {
var t_7 = t_4.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_7);
output += "\n";
env.getTemplate("front/components/Link/Link.jinja", false, "assets/app/front/pages/Responsible/Responsible.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "Link")) {
var t_11 = t_8.Link;
} else {
cb(new Error("cannot import 'Link'")); return;
}
context.setVariable("Link", t_11);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
output += t_12;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_15,t_14) {
if(t_15) { cb(t_15); return; }
output += t_14;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "ResponsiblePage";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"Responsible\">\n        <a class=\"Responsible-logo\" href=\"/\">";
output += runtime.suppressValue((lineno = 9, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "svgSprite"), "svgSprite", context, ["logo"])), env.opts.autoescape);
output += "</a>\n\n        <div class=\"Responsible-content\">\n            <h1 class=\"Responsible-header\">Об ответственном употреблении алкоголя</h1>\n\n            <div class=\"Responsible-text\">\n                <p>Компания последовательно выступает за ответственное употребление алкоголя и \n                за общую культуру пития. В первую очередь, мы призываем к культурному и умеренному \n                потреблению пива, которое должно дарить удовольствие, не вызывая негативных последствий.</p>\n\n                <p>Российское законодательство запрещает употребление и продажу алкогольной \n                продукции лицам, не достигшим 18 лет. Действие алкоголя на подростка сильнее, чем на \n                взрослого, и впоследствии сильно сказывается на работе его головного мозга. Почти в 80% случаев \n                употребления подростками алкогольной продукции приводит к привыканию, неконтролируемому в \n                будущем и требующему профессионального лечения.</p>\n\n                <p>Каждый взрослый человек сам несет ответственность за потребление продукции, содержащей \n                алкоголь. Однако мы обращаем ваше внимание на недопустимость вождения в нетрезвом \n                состоянии. Это может привести к серьезным последствиям как для самого водителя, так и для \n                окружающих его людей.</p>\n\n                <p>Кроме того, нежелательно употребление алкоголя в период беременности и в период приема \n                любых медицинских препаратов.</p>\n\n                <p>Ответственное употребление напитков, содержащих алкоголь, совместимо со здоровым \n                образом жизни, в то время как неумеренное или безответственное может негативным образом \n                повлиять на личную жизнь человека, его здоровье и социальный статус.</p>\n            </div>\n\n            <div class=\"Responsible-link\">\n                ";
output += runtime.suppressValue((lineno = 39, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "Link"), "Link", context, [runtime.makeKeywordArgs({"title": "Вернуться на главную страницу","href": "/","icon": "arrowInfo"})])), env.opts.autoescape);
output += "\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Responsible/Responsible.jinja"] , dependencies)